module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("My name is Gaylord ‘Gabe’ Kemling. I was a licensed Wisconsin private detective; or called a Wisconsin private eye. I worked for and with Steve Brickman who owned a detective agency that was licensed in Wisconsin for years. The agency shut down in March of 2016 when Steve Brickman passed away. His death was very hard on me.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("During the partnership of doing investigations over the years, Steve and I occasionally, after a day’s work was done, would sit down and write about that day’s investigation work, if it was worth writing about. We could complete the story, type it out, edit it and then preserve the story for future use. We usually did all this work throughout the night, but sometimes would wait until the next morning.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("These are real detective stories that Steve and I worked together on over the years. When at times we met the good, bad, and the ugly.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('img', {
    staticClass: "center",
    staticStyle: {
      "width": "3.39583in",
      "height": "3.22575in",
      "filter": "grayscale(100%)"
    },
    attrs: {
      "alt": "",
      "src": "media/file0.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("These are real life stories that took place in the life of a private detective in the state of Wisconsin, and other states, in the past fifteen years, 2005 to 2020. I have enclosed a collection of twelve stories from my many years as a private detective.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0